// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ResponseRolloutStatus = {
  RolloutStatusAborted: 'Aborted',
  RolloutStatusCompleted: 'Completed',
  RolloutStatusPausing: 'Pausing',
  RolloutStatusPaused: 'Paused',
  RolloutStatusAwaitingApproval: 'AwaitingApproval',
  RolloutStatusTransferred: 'Transferred',
  RolloutStatusDeploying: 'Deploying',
  RolloutStatusTransferring: 'Transferring',
  RolloutStatusUnknown: 'Unknown',
} as const;
export type ResponseRolloutStatus =
  (typeof ResponseRolloutStatus)[keyof typeof ResponseRolloutStatus];

export function instanceOfResponseRolloutStatus(value: any): boolean {
  for (const key in ResponseRolloutStatus) {
    if (Object.prototype.hasOwnProperty.call(ResponseRolloutStatus, key)) {
      if (
        ResponseRolloutStatus[key as keyof typeof ResponseRolloutStatus] ===
        value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ResponseRolloutStatusFromJSON(
  json: any,
): ResponseRolloutStatus {
  return ResponseRolloutStatusFromJSONTyped(json, false);
}

export function ResponseRolloutStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutStatus {
  return json as ResponseRolloutStatus;
}

export function ResponseRolloutStatusToJSON(
  value?: ResponseRolloutStatus | null,
): any {
  return value as any;
}

export function ResponseRolloutStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ResponseRolloutStatus {
  return value as ResponseRolloutStatus;
}
